import styles from "./Sliders.module.css";

const IconValueSlider = ({
  sliderValue,
  sliderMin,
  sliderMax,
  sliderStep,
  onChangeFunction,
  Icon,
  showIcon = true,
  showValue = true,
}) => {
  return (
    <div className="flex flex-row items-center justify-between h-10 w-full Xbg-yellow-500">
      {showIcon && (
        <div className="flex flex-[1]">
          <Icon className="w-7 h-7 text-neutral-400 fill-neutral-400  Xbg-blue-500" />
        </div>
      )}
      {showValue && (
        <div className="flex flex-[1] px-5 2xl:px-1">
          <p className="text-lg font-medium text-neutral-400">{sliderValue}</p>
        </div>
      )}
      <div className="flex flex-[8]">
        <input
          className={styles["slider"]}
          type="range"
          min={sliderMin}
          max={sliderMax}
          step={sliderStep}
          value={sliderValue}
          onChange={onChangeFunction}
        ></input>
      </div>
    </div>
  );
};

export { IconValueSlider };
